module.exports = __webpack_public_path__ + "static/media/04.1c6381a0.svg";